import { Slider } from "antd";
import React, { useState } from "react";

const SlideProgress = () => {
  const [inputValue, setInputValue] = useState(1);
  const maxValue = 35000;

  const onChange = (newValue) => {
    setInputValue(newValue);
  };

  const percentValue = ((inputValue / maxValue) * 100).toFixed(2);

  return (
    <div className="slide_progress_bar">
      <div className="bar_header">
        <p>{percentValue}%</p>
        <p>
          ${inputValue} / ${maxValue}
        </p>
      </div>
      <Slider min={0} max={maxValue} onChange={onChange} value={inputValue} />
    </div>
  );
};

export default SlideProgress;
